var map = {
	"./1.png": "aff7",
	"./2.png": "dcd4",
	"./3.png": "88b9",
	"./4.png": "8013",
	"./5.png": "8970",
	"./6.png": "5f9c",
	"./7.png": "776c",
	"./8.png": "ae46",
	"./9.png": "b94d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3235";